"use client"

import React from 'react';
import {motion} from "framer-motion"
import styles from "./SplashScreen.module.css";
import {useRouter} from "@/i18n/routing"
import useTimeout from 'beautiful-react-hooks/useTimeout';
import {useLocale} from "use-intl";
import {useAppStore} from "@/store/AppStore";
import LogoP from "@/components/Logo/LogoP";

const SplashScreen = () => {
  const locale = useLocale()
  const router = useRouter()
  const appStore = useAppStore()
  useTimeout(() => {
    router.push(`${locale}/home`)
  }, appStore.splash ? 3000 : 0);

  return (
    <div className={styles.bkg}>
      <motion.div
        className={styles.box}
        initial={{opacity: 0, scale: 0}}
        animate={{opacity: 1, scale: 1}}
        transition={{duration: 2}}
        onAnimationComplete={() => {
          appStore.setSplash(false)
        }}
      >
        <LogoP/>
      </motion.div>
    </div>
  );
};

export default SplashScreen;
